export default {"src":"/_next/static/media/contract.aee35823.svg","height":81,"width":81,"blurWidth":0,"blurHeight":0};